import $ from 'jquery';
import Authenticate from './Authenticate';
import Fetch from './Fetch';


class Request  extends Fetch {

    constructor() {
        super();
    }

    /**
     * Send Request
     * 
     * @param {*} config 
     */
    send(config) {
        if (config) {
            $.extend(this.defaults, config);
        }
        let that = this;

        //check authenticate is required for API
        if (this.defaults.authenticate) {
            
            new Authenticate().getAccessToken(that.defaults.client_id, that.defaults.canUsePublicAuth)
            .then(data => { 
                window.ajaxAuthRequestLoading = false;               
                that.defaults.headers = { 'Authorization': data['token_type'] + ' ' + data['access_token'] };

                that.defaults.publicAuth = (data['type'] === 'public') ? true : false;

                that.fetch(that.defaults);
        
            }).catch(error => {
                console.error(error);
            });
        } else {
            that.fetch(this.defaults);
        }
    }    
    
}

export default Request;